import { render, staticRenderFns } from "./QuotationMGT.vue?vue&type=template&id=3c609013&scoped=true&"
import script from "./QuotationMGT.vue?vue&type=script&lang=js&"
export * from "./QuotationMGT.vue?vue&type=script&lang=js&"
import style0 from "./QuotationMGT.vue?vue&type=style&index=0&id=3c609013&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c609013",
  null
  
)

export default component.exports